import _ from "lodash";
import {
  Component,
} from "react";

import store from "CommonState/store";
import {
  ControlGenerators,
} from "CommonComponents/detail-view";
import Confirmation from "CommonComponents/confirmation";
import {
  Row,
} from "react-bootstrap";
import apifetch from "CommonCore/apifetch";
import {
  validateVertrag,
} from "Apis/massnahme-api";
import {
  setupLookups,
} from "App/shk-form-tab";
import {
  ANTRAGSTELLERMODUS,
  ASTMODUSKEY,
  getModusFromAntrag,
  ANTRAGSTYPEN,
} from "App/constants";
import antragApi from "Apis/antrag-api";

const schemaTyp = {
  table: [{
    field: "a_katid",
    display: "Vertragstyp",
    type: "select",
    inject: ["k_antragstyp"],
  }],
};

setupLookups(schemaTyp);

@store("k_einrichtungLookup", "k_antragstyp", "k_vertragsartLookup", "k_pfaartLookup", "user")
@antragApi.current
export default class AntragTypÄndernPopup extends Component {
  constructor() {
    super();
    this.state = { selektiert: [] };
  }

  render() {
    const { onCancel, currentAntrag } = this.props;
    const { errorMessage } = this.state;
    const modus = ANTRAGSTELLERMODUS[getModusFromAntrag(currentAntrag)];
    const hkvertrag = getModusFromAntrag(currentAntrag) == ASTMODUSKEY.Hilfskraft;

    schemaTyp.table[0].choices = lookup => () => _.uniqBy(_.map(
      _.filter(lookup, l => modus.vertragsarten.indexOf(l.art_id) >= 0 &&
        !(l.kat_id === ANTRAGSTYPEN.WIEDERHOLUNGSANTRAG && hkvertrag)),
      x => ({ value: x.kat_id, label: x.kat_kbez }),
    ), choice => choice.value);

    const cg = id => {
      const setValue = (schema, value) => {
        this.setState({ [schema.field]: value });
      };
      return <Row style={{ verticalAlign: "middle" }}>{ControlGenerators.select({
        entity: this.state,
        leftCol: 2,
        rightCol: 10,
        schema: schemaTyp.table[id],
        onChange: setValue,
        injects: this.props,
      })}</Row>;
    };

    return (

      <Confirmation
        header='Antragstyp ändern'
        action='Antragstyp ändern'
        actionStyle='primary'
        onCancel={onCancel}
        onConfirm={this.onConfirm}
        errorMessage={errorMessage}
      >
        <p>Bitte wählen Sie den neuen Antragstyp aus</p>

        <br />

        <div className='box-panel'>
          <div className='detail-form' style={{ paddingLeft: "15px", paddingRight: "15px" }}>
            <form className='form-horizontal'>
              {cg(0)}
            </form>
          </div></div>

      </Confirmation>
    );
  }

  onConfirm = async() => {
    const { currentAntrag } = this.props;
    const { a_katid } = this.state;

    const modus = getModusFromAntrag(currentAntrag);
    const werkvertrag = modus == ASTMODUSKEY.WerkPrivat;
    const lehrvertrag = modus == ASTMODUSKEY.Lehrauftrag;
    const tarifvertrag = modus == ASTMODUSKEY.Tarif;

    if (_.isEmpty(a_katid)) {
      this.setState({ errorMessage: "Bitte wählen Sie einen Vertragstyp aus" });
      return false;
    }

    if (!werkvertrag && !lehrvertrag && !tarifvertrag) {
      // Vertragsarten für Änderung prüfen (für Hilfskräfte)
      const statusArten = [];
      const result = await validateVertrag(currentAntrag.massnahmen, this.state, this.props); // Props wg. Lookups übergeben
      _.map(result, record => {
        statusArten.push({ nachricht: `${ record.index ? `Maßnahme ${ record.index + 1 }:` : "" } ${ record.text }` });
      });
      if (!_.isEmpty(statusArten)) {
        this.setState({ errorMessage: statusArten[0].nachricht });
        return false;
      }
    }

    try {
      const result = await apifetch("/api/shkantrag/antrag/typ", {
        method: "POST",
        body: { a_id: currentAntrag.a_id, a_katid: a_katid },
      });
      this.props.onClose(result.a_id);
    } catch(err) {
      this.setState({
        errorMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
      });
    }
  };
}

